import React from 'react';
import cm from 'classnames';
import { UseFormRegister } from 'react-hook-form';

import { InputRadio } from './elements/input-radio';
import { InputHeader } from './elements/input-header';
import styles from './_input.module.scss';

interface Radio {
  label: string;
  value: number;
}

interface Props {
  header?: string | React.ReactNode;
  className?: string;
  defaultValue?: number;
  id: string | number;
  data: Radio[];
}

type PropsType = Props &
  Omit<React.InputHTMLAttributes<HTMLInputElement>, keyof Props> &
  ReturnType<UseFormRegister<Record<string, unknown>>>;

const InputRadioGroup = React.forwardRef<HTMLInputElement, PropsType>(
  ({ header, className, id, data, defaultValue, ...rest }: PropsType, ref) => {
    return (
      <div className={cm(styles.InputRadioGroup, className)}>
        <InputHeader>{header}</InputHeader>
        {data.map((el) => (
          <InputRadio
            key={el.value}
            id={`${id}_${el.value}`}
            defaultChecked={defaultValue === el.value}
            label={el.label}
            {...rest}
            ref={ref}
            value={el.value}
          />
        ))}
      </div>
    );
  }
);
InputRadioGroup.displayName = 'InputRadioGroup';
export { InputRadioGroup };
